module.exports = __webpack_public_path__ + "img/beam-body-2.78a68dda.png";